import React from "react";
import PropTypes from "prop-types";
import styles from '../../styles/components/_shared/YoutubeEmbed.module.scss';

// The iframe was eager, so every visitor to /about-us, /solar-academy and
// /help-centre downloaded the YouTube player whether or not they scrolled to
// the video. loading="lazy" defers it until the frame is near the viewport.
//
// The better version of this is click-to-play against a still image, which
// avoids the player entirely until someone asks for it; a YouTube embed is
// close to a megabyte of third-party JavaScript. Left as a follow-up because
// it changes what the section looks like, and this one-line change takes the
// cost off the initial load of all three pages without touching the design.
const YoutubeEmbed = ({ embedId }) => (
  <div className={styles.videoResponsive}>
    <iframe
      width={640}
      height={360}
      loading="lazy"
      allowFullScreen
      style={{ border: 'none', borderRadius: '1rem', margin: 0, maxWidth: '100%' }}
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      title="YouTube video"
    />
  </div>
);

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired
};

export default YoutubeEmbed;